// src/pages/logistica/ForecastMapeo.jsx
import { useEffect, useState } from 'react';
import api from '../../services/api';

export default function ForecastMapeo() {
  const [filas, setFilas] = useState([]);
  const [articulosReales, setArticulosReales] = useState([]);
  const [manual, setManual] = useState({}); // { forecast_nombre: true } — cuáles están en modo texto libre
  const [cargando, setCargando] = useState(true);
  const [guardandoNombre, setGuardandoNombre] = useState(null);
  const [mensaje, setMensaje] = useState(null);

  async function cargar() {
    try {
      setCargando(true);
      const [resMapeo, resArticulos] = await Promise.all([
        api.get('/api/logistica/forecast/mapeo'),
        api.get('/api/logistica/caducidades'), // reutiliza la lista de artículos PT ya conocidos
      ]);
      setFilas(resMapeo.data.data);
      const nombresUnicos = [...new Set(resArticulos.data.data.map((l) => l.articulo))].sort();
      setArticulosReales(nombresUnicos);
    } catch (err) {
      console.error(err);
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargar(); }, []);

  function handleCambiarArticulo(nombre, valor) {
    setFilas((prev) => prev.map((f) => (f.forecast_nombre === nombre ? { ...f, articulo_real: valor, ignorar: false } : f)));
  }

  async function handleGuardar(nombre) {
    const fila = filas.find((f) => f.forecast_nombre === nombre);
    try {
      setGuardandoNombre(nombre);
      setMensaje(null);
      await api.put(`/api/logistica/forecast/mapeo/${encodeURIComponent(nombre)}`, { articulo_real: fila.articulo_real });
      setMensaje({ tipo: 'ok', texto: `✓ ${nombre} → ${fila.articulo_real}` });
      cargar();
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: err.response?.data?.error || `No se pudo guardar ${nombre}.` });
    } finally {
      setGuardandoNombre(null);
    }
  }

  async function handleIgnorar(nombre) {
    try {
      setGuardandoNombre(nombre);
      setMensaje(null);
      await api.put(`/api/logistica/forecast/mapeo/${encodeURIComponent(nombre)}`, { ignorar: true });
      setMensaje({ tipo: 'ok', texto: `✓ ${nombre} marcado como subtotal (ignorado).` });
      cargar();
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: err.response?.data?.error || `No se pudo actualizar ${nombre}.` });
    } finally {
      setGuardandoNombre(null);
    }
  }

  if (cargando) return <div style={styles.contenedor}>Cargando...</div>;

  const pendientes = filas.filter((f) => !f.articulo_real && !f.ignorar).length;

  return (
    <div style={styles.contenedor} className="contenedor-captura">  
      <h1 style={styles.titulo}>Mapeo de Forecast</h1>
      <p style={styles.subtitulo}>
        Asigna cada nombre del Excel a su artículo real, o márcalo "ignorar" si es un subtotal (GRANOLA, CEREAL, Total general, etc.).
        {pendientes > 0 && <span style={styles.pendientesAviso}> {pendientes} pendiente{pendientes === 1 ? '' : 's'}.</span>}
      </p>

      {mensaje && <div style={{ ...styles.mensaje, color: mensaje.tipo === 'ok' ? '#3E7C5A' : '#B23A48' }}>{mensaje.texto}</div>}

      <div style={styles.tarjeta}>
        {filas.map((f) => {
          const pendiente = !f.articulo_real && !f.ignorar;
          return (
            <div key={f.forecast_nombre} style={{ ...styles.fila, ...(pendiente ? styles.filaPendiente : {}), ...(f.ignorar ? styles.filaIgnorada : {}) }}>
              <div style={styles.nombreForecast}>{f.forecast_nombre}</div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                {f.ignorar ? (
                  <span style={styles.tagIgnorado}>ignorado</span>
                ) : manual[f.forecast_nombre] ? (
                  <>
                    <input
                      type="text"
                      placeholder="nombre exacto en NetSuite…"
                      value={f.articulo_real || ''}
                      onChange={(e) => handleCambiarArticulo(f.forecast_nombre, e.target.value)}
                      style={{ ...styles.select, ...(pendiente ? styles.selectPendiente : {}) }}
                    />
                    <button
                      onClick={() => setManual((prev) => ({ ...prev, [f.forecast_nombre]: false }))}
                      style={styles.botonIgnorar}
                      title="Volver a la lista de artículos con inventario"
                    >
                      lista
                    </button>
                    <button
                      onClick={() => handleGuardar(f.forecast_nombre)}
                      disabled={guardandoNombre === f.forecast_nombre || !f.articulo_real}
                      style={styles.botonGuardar}
                    >
                      {guardandoNombre === f.forecast_nombre ? '...' : 'Guardar'}
                    </button>
                  </>
                ) : (
                  <>
                    <select
                      value={f.articulo_real || ''}
                      onChange={(e) => handleCambiarArticulo(f.forecast_nombre, e.target.value)}
                      style={{ ...styles.select, ...(pendiente ? styles.selectPendiente : {}) }}
                    >
                      <option value="" disabled>Elegir artículo…</option>
                      {articulosReales.map((a) => (
                        <option key={a} value={a}>{a}</option>
                      ))}
                    </select>
                    <button
                      onClick={() => setManual((prev) => ({ ...prev, [f.forecast_nombre]: true }))}
                      style={styles.botonIgnorar}
                      title="El artículo no tiene inventario todavía — escribir el nombre exacto de NetSuite"
                    >
                      no está en la lista
                    </button>
                    <button
                      onClick={() => handleGuardar(f.forecast_nombre)}
                      disabled={guardandoNombre === f.forecast_nombre || !f.articulo_real}
                      style={styles.botonGuardar}
                    >
                      {guardandoNombre === f.forecast_nombre ? '...' : 'Guardar'}
                    </button>
                  </>
                )}
                <button
                  onClick={() => handleIgnorar(f.forecast_nombre)}
                  disabled={guardandoNombre === f.forecast_nombre}
                  style={styles.botonIgnorar}
                  title="Marcar como subtotal / no es un artículo real"
                >
                  ignorar
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const styles = {
  contenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42', maxWidth: '700px' },
  titulo: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '4px' },
  subtitulo: { fontSize: '12px', color: '#8A7690', marginBottom: '18px' },
  pendientesAviso: { color: '#B23A48', fontWeight: 600 },
  mensaje: { fontSize: '13px', marginBottom: '14px', fontWeight: 600 },
  tarjeta: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '18px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)', display: 'flex', flexDirection: 'column', gap: '14px' },
  fila: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '14px', paddingBottom: '14px', borderBottom: '1px solid #F0E9E0', flexWrap: 'wrap' },
  filaPendiente: { background: '#FDF3F1', margin: '0 -18px', padding: '10px 18px', borderRadius: '8px' },
  filaIgnorada: { opacity: 0.55 },
  nombreForecast: { fontSize: '14px', fontWeight: 700, color: '#2A1830' },
  select: { padding: '7px 10px', fontSize: '13px', border: '1px solid #D6A644', borderRadius: '6px', fontFamily: 'Inter, sans-serif', background: '#FFFDF7', minWidth: '220px' },
  selectPendiente: { borderColor: '#B23A48' },
  botonGuardar: { padding: '6px 14px', fontSize: '12px', fontWeight: 600, color: '#6E4F80', background: '#EFE9F3', border: '1px solid #A98BB8', borderRadius: '6px', cursor: 'pointer' },
  botonIgnorar: { padding: '6px 12px', fontSize: '11px', color: '#8A7690', background: 'transparent', border: '1px solid #E6DDD2', borderRadius: '6px', cursor: 'pointer' },
  tagIgnorado: { fontSize: '11px', fontWeight: 600, color: '#8A7690', background: '#F0E9E0', padding: '4px 10px', borderRadius: '10px' },
};